import router from '@/router'
//页面进度条
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import TokenCache from '@/utils/cache/TokenCache'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['NoT', 'Login', 'UserSign'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  console.log(to, from, next)
  NProgress.start() // start progress bar

  // 已授权
  if (TokenCache.getToken()) {
    //设置vuex登录状态为已登录
    if (to.path === '/') {
      next({ path: '/Login' })
      NProgress.done()
    } else {
      const redirect = decodeURIComponent(from.query.redirect || to.path)
      // 桌面特殊处理
      if (to.path === '/404') {
        next()
      } else {
        if (to.path === redirect) {
          next()
        } else {
          // 跳转到目的路由
          next({ path: redirect })
        }
      }
    }
  } else {
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next({ path: '/Login' })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  window.scroll(0, 0)
  NProgress.done() // finish progress bar
})
